import Vue from "vue";
import Vuex from "vuex";
import { SessionStorageAccessor } from "./SessionStorageAccessor";
import { State } from "./State";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: new State(),
  getters: {
    configuration: state => state.configuration,
    token: state => state.token,
    user: state => state.user,
    folderGuid: state => state.folderGuid,
  },
  mutations: {
    setConfiguration(state, configuration) {
      // stateに直接入れると何故かgetterによる更新がされない
      Vue.set(state, "configuration", configuration);
      SessionStorageAccessor.configuration = configuration;
    },
    setToken(state, token) {
      // stateに直接入れると何故かgetterによる更新がされない
      Vue.set(state, "token", token);
      SessionStorageAccessor.token = token;
    },
    setUser(state, user) {
      // stateに直接入れると何故かgetterによる更新がされない
      Vue.set(state, "user", user);
      SessionStorageAccessor.user = user;
    },
    setFolderGuid(state, folderGuid) {
      // stateに直接入れると何故かgetterによる更新がされない
      Vue.set(state, "folderGuid", folderGuid);
      SessionStorageAccessor.folderGuid = folderGuid;
    },
},
  actions: {
    setConfiguration(context, configuration) {
      context.commit("setConfiguration", configuration);
    },
    setToken(context, token) {
      context.commit("setToken", token);
    },
    setUser(context, user) {
      context.commit("setUser", user);
    },
    setFolderGuid(context, folderGuid) {
      context.commit("setFolderGuid", folderGuid);
    },
},
  modules: {
  }
});

export default store;
